<template>
  <div class="delete-confirm">
    <div class="message-section">
      <rp-sprite :name="icon" v-if="icon"/>
      <div class="message-body">
        <span class="message-text" v-if="messageText" v-html="messageText"></span>
        <span class="message-type" v-if="messageType">{{messageType}}</span>
        <span class="user-type" v-if="userType">{{userType}}</span>
        <span class="user-name" v-if="userName">{{userName}}</span>
      </div>
    </div>
    <div class="button-group">
      <rp-button class="cancel" @click="cancel">{{ this.btnCancelText ? this.btnCancelText : "CANCEL" }}</rp-button>
      <rp-button type="primary" @click="confirm" class="confirm">{{ this.btnConfirmText ? this.btnConfirmText : "CONFIRM" }}</rp-button>
    </div>
  </div>
</template>

<script>
import Button from './inputs/Button'
import Sprite from './Sprite'

export default {
  props: {
    icon: {type: String},
    messageType: {type: String},
    userType: {type: String},
    userName: {type: String},
    confirm: {type: Function},
    cancel: {type: Function},
    messageText: {type: String},
    btnCancelText: {type: String},
    btnConfirmText: {type: String}
  },

  components: {
    'rp-button': Button,
    'rp-sprite': Sprite
  }
}
</script>

<style lang="sass" scoped>
  @import '../../styles/base/variables'
  @import '../../styles/helpers/mixins'

  .delete-confirm
    display: flex
    flex-direction: column
    max-width: 500px
    width: 100%
    margin: 0 auto
    padding: 20px
    border-radius: 2px
    background: $color-panel-bg
    box-shadow: 2px 3px 5px 0px $color-shadow

    .message-section
      display: flex
      align-items: center

      .sprite
        width: 30px
        height: 30px
        fill: $color-error

      .message-body
        width: 85%
        margin-left: 20px

        span
          font-size: 12px
          &.message-type, &.user-name
            text-transform: capitalize
          &.user-type
            text-transform: lowercase
          &.user-name
            font-weight: $font-bold

    .button-group
      display: flex
      align-items: center
      justify-content: space-between

      .cancel
        color: $color-soft-black
        border: 1px solid $color-soft-black
      .confirm
        color: $color-panel-bg

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/DeleteConfirm.vue